import React from 'react'

import { Switch, SwitchHTMLProps, SwitchProps } from '@rmwc/switch'
import '@rmwc/switch/styles'
import styled from 'styled-components'

type ThemedSwitchProps = SwitchProps & SwitchHTMLProps

const StyledSwitch = styled(Switch)<ThemedSwitchProps>`
  /* Set CSS custom properties for MDC Switch track colors */
  --mdc-switch-selected-track-color: ${(props) => props.theme.colors.primaryLight};
  --mdc-switch-selected-hover-track-color: ${(props) => props.theme.colors.primaryLight};
  --mdc-switch-selected-focus-track-color: ${(props) => props.theme.colors.primaryLight};
  --mdc-switch-selected-pressed-track-color: ${(props) => props.theme.colors.primaryLight};

  --mdc-switch-disabled-selected-track-color: ${(props) => props.theme.colors.cosmicShade3};
  --mdc-switch-disabled-unselected-track-color: ${(props) => props.theme.colors.cosmicShade3};

  /* Set CSS custom properties for MDC Switch handle (thumb) colors */
  --mdc-switch-selected-handle-color: ${(props) => props.theme.colors.primary};
  --mdc-switch-selected-hover-handle-color: ${(props) => props.theme.colors.primary};
  --mdc-switch-selected-focus-handle-color: ${(props) => props.theme.colors.primaryDark};
  --mdc-switch-selected-pressed-handle-color: ${(props) => props.theme.colors.primaryDark};

  /* Hide icons in switch handle */
  .mdc-switch__icons {
    display: none;
  }

  /* Thumb styling */
  .mdc-switch__thumb {
    box-shadow: none;
  }
`

const ThemedSwitch = (props: ThemedSwitchProps) => <StyledSwitch {...props} />

ThemedSwitch.displayName = 'Switch'
export default ThemedSwitch
